import { render, staticRenderFns } from "./DatabaseConnectionForm.vue?vue&type=template&id=2638d272&"
import script from "./DatabaseConnectionForm.vue?vue&type=script&lang=js&"
export * from "./DatabaseConnectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports